import React from 'react'
import BreadCrum from '../components/BreadCrum'
import Color from '../components/Color'
import Container from '../components/Container'
import Meta from '../components/Meta'

const CompareProduct = () => {
  return (
    <>
        <Meta title='Compare Products'/>
        <BreadCrum title='Compare Products' />
        <Container class1="compare-product-wrapper py-3 home-wrapper-2">
            <div className="row">
                <div className="col-3">
                    <div className="compare-product-card position-relative">
                        <img src="images/cross.svg" alt="cross" className='position-absolute cross' />
                        <div className="product-card-img">
                            <img src="images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                        <div className="compare-product-details">
                            <h5 className="title">Lorem, ipsum dolor.</h5>
                            <h6 className="price mt-3">$20</h6>
                            <div>
                                <div className="product-details">
                                    <h6>Brand:</h6>
                                    <p>lorem</p>
                                </div>
                                <div className="product-details">
                                    <h6>Types:</h6>
                                    <p>lorem</p>
                                </div>
                                <div className="product-details">
                                    <h6>Availablity:</h6>
                                    <p>In Stock</p>
                                </div>
                                <div className="product-details">
                                    <h6>Color:</h6>
                                    <Color />
                                </div>
                                <div className="product-details">
                                    <h6>Size:</h6>
                                    <div className="d-flex gap-10"> 
                                        <p>S</p>
                                        <p>M</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="compare-product-card position-relative">
                        <img src="images/cross.svg" alt="cross" className='position-absolute cross' />
                        <div className="product-card-img">
                            <img src="images/watch.jpg" alt="watch" className='img-fluid' />
                        </div>
                        <div className="compare-product-details">
                            <h5 className="title">Lorem, ipsum dolor.</h5>
                            <h6 className="price mt-3">$20</h6>
                            <div>
                                <div className="product-details">
                                    <h6>Brand:</h6>
                                    <p>lorem</p>
                                </div>
                                <div className="product-details">
                                    <h6>Types:</h6>
                                    <p>lorem</p>
                                </div>
                                <div className="product-details">
                                    <h6>Availablity:</h6>
                                    <p>In Stock</p>
                                </div>
                                <div className="product-details">
                                    <h6>Color:</h6>
                                    <Color />
                                </div>
                                <div className="product-details">
                                    <h6>Size:</h6>
                                    <div className="d-flex gap-10"> 
                                        <p>S</p>
                                        <p>M</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default CompareProduct